import { styled } from '@mui/material/styles';

export const Screen = styled('div')`
  padding: 0 !important;
  color: #10213f;
  font-size: var(--v3-body-size, 14px);
`;

export const Content = styled('div')`
  padding: 24px 18px 20px;
`;

export const Title = styled('h2')`
  margin: 0 0 20px;
  color: #10213f;
  font-size: var(--v3-title-size, 20px) !important;
  line-height: 1.35 !important;
  font-weight: 700;
`;

export const Summary = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
  font-size: 14px;

  strong {
    flex: 0 0 auto;
    font-size: 22px;
  }
`;

export const DiscountLine = styled('div')`
  margin-bottom: 18px;
  color: #65728a;
  font-size: 14px;
`;

export const MethodButton = styled('button')<{
  accent: 'beeline' | 'cashier';
}>`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 112px;
  margin-top: 12px;
  padding: 20px 18px 20px 26px;
  border: 1px solid #ccd6e8;
  border-radius: 10px;
  background: #fff;
  color: #10213f;
  text-align: left;
  cursor: pointer;
  transition: border-color 150ms ease, box-shadow 150ms ease,
    transform 150ms ease;

  &::before {
    content: '';
    position: absolute;
    inset: -1px auto -1px -1px;
    width: 9px;
    border-radius: 10px 0 0 10px;
    background: ${({ accent }) =>
      accent === 'beeline' ? '#ffd43b' : 'transparent'};
  }

  span {
    display: flex;
    flex-direction: column;
    gap: 9px;
  }

  strong {
    font-size: 15px;
    line-height: 1.3;
  }

  small {
    color: #65728a;
    font-size: 14px;
    line-height: 1.45;
  }

  .pharmacist-bonus-hint {
    color: #007d63;
  }

  svg {
    flex: 0 0 auto;
  }

  &:hover {
    border-color: #5268ed;
    box-shadow: 0 5px 14px rgba(63, 86, 226, 0.12);
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 3px solid rgba(63, 86, 226, 0.25);
    outline-offset: 2px;
  }
`;

export const BackButton = styled('button')`
  width: fit-content;
  min-height: 44px;
  margin-top: 20px;
  padding: 0 12px;
  border: 1px solid #c7d1ff;
  border-radius: 8px;
  background: #fff;
  color: #3f56e2;
  font: inherit;
  font-size: var(--v3-control-size, 15px);
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #f7f8ff;
  }

  &:focus-visible {
    outline: 3px solid rgba(63, 86, 226, 0.22);
    outline-offset: 2px;
  }
`;

export const Confirmation = styled('div')`
  p {
    margin: -8px 0 18px;
    color: #65728a;
    font-size: 14px;
    line-height: 1.5;
  }
`;

export const OrderMeta = styled('div')`
  margin-bottom: 12px;
  border: 1px solid #dce3f0;
  border-radius: 8px;
  overflow: hidden;

  div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    min-height: var(--v3-row-height, 48px);
    padding: 10px 16px;
  }

  .meta-title {
    min-height: auto;
    justify-content: flex-start;
    padding: 14px 16px;
    color: #10213f;
    font-size: 15px;
    font-weight: 700;
  }

  div + div {
    border-top: 1px solid #e8edf5;
  }

  span {
    color: #65728a;
    font-size: 14px;
  }

  strong {
    min-width: 0;
    overflow-wrap: anywhere;
    color: #10213f;
    font-size: 14px;
    font-weight: 700;
    text-align: right;
  }
`;

export const PayableBox = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 15px 16px;
  border: 1px solid #dce3f0;
  border-radius: 8px;
  background: #f7f9fc;

  span {
    color: #65728a;
    font-size: 14px;
  }

  strong {
    font-size: 22px;
  }
`;

export const PrimaryButton = styled('button')`
  width: 100%;
  min-height: 48px;
  margin-top: 20px;
  border: 0;
  border-radius: 8px;
  background: #3f56e2;
  color: #fff;
  font: inherit;
  font-size: var(--v3-control-size, 15px);
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.65;
    cursor: wait;
  }
`;

export const SecondaryButton = styled('button')`
  width: 100%;
  min-height: 44px;
  margin-top: 8px;
  border: 1px solid #c7d1ff;
  border-radius: 8px;
  background: #fff;
  color: #3f56e2;
  font: inherit;
  font-size: var(--v3-control-size, 15px);
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #f7f8ff;
  }

  &:focus-visible {
    outline: 3px solid rgba(63, 86, 226, 0.22);
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.55;
  }
`;
